import { requests } from './creatorApiAgent';
import type { TPageSnapshot } from '../models/CourseViewModels';

/**
 * The backend's `CoursePage` controller. Request and envelope plumbing lives in `creatorApiAgent`.
 */
const CoursePage = {
  /** The page snapshot of every page in the course that has one, for an author who can reach the course. */
  getPageSnapshots: (courseID: number): Promise<TPageSnapshot[]> => requests.postEnvelope<TPageSnapshot[]>('/CoursePage/GetPageSnapshots', { courseID }).then((snapshots) => snapshots ?? []),
};

const coursePageAgent = {
  CoursePage,
};

export default coursePageAgent;
